import React from 'react';

const NotFound = () => {
    const handleHomeClick = () => {
        window.location = '/';
    };
    return (
        <>
            <div className="flex-column-div justify-content-center align-items-center">
                <h1>Oops!</h1>
                <h2>404 - The page you'r looking for can't be found</h2>
                <button className="btn btn-primary" onClick={handleHomeClick}>Go To Home</button>
            </div>
        </>
    );
};
export default NotFound;